import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { UserType } from '../model/user.model';

@Injectable()
export class UsertypeService {
  userTypes$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(private apiService: ApiService) {
    this.getUserTypes();
  }

  async getUserTypes() {
    try {
      const userTypes: any = await this.apiService.get('user-types');
      const userTypesArr = Object.values(userTypes);
      this.userTypes$.next(userTypesArr);
    } catch (err) {
      console.log('Could not load user types.', err);
    }
  }

  filterTypesByBrand(types: any[]): any[] {
    return types.filter((item) => item.name === UserType.INTERNAL || item.name === UserType.EXTERNAL);
  }
}
